export class I18nUtils {
    public static SUPPORTED_LANGUAGES = ["fr"];
    public static DEFAULT_LANGUAGE = "fr";
}
